module.exports = __webpack_public_path__ + "static/media/t-rex-tarjeta-memorama.3b3d267a.svg";